import { allowAccess } from "../../utils/accessControl";
import { Navigate } from "react-router";


const ProtectedRoute = ({ allowedRole, path = "", redirectPath = '/login', children }) => {
    const nav = <Navigate to={redirectPath} replace />
    if (!allowAccess(allowedRole)) {
        return nav
    }
    return children
    
  };

export default ProtectedRoute
